var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0,0,256,256",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#555555",
    strokeWidth: 16,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.97983,246.04035c-32.59594,0 -59.02017,-26.42423 -59.02017,-59.02017v-118.04035c0,-32.59594 26.42423,-59.02017 59.02017,-59.02017h118.04035c32.59594,0 59.02017,26.42423 59.02017,59.02017v118.04035c0,32.59594 -26.42423,59.02017 -59.02017,59.02017z",
    id: "shape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "#555555",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.17,15.426l-23.234,26.361c0,0 4.628,2.745 5.777,6.191c5.234,-6.383 25.851,-29.872 25.851,-29.872c4.117,-4.404 -5.745,-14.362 -11.362,-8.426c-5.617,6.128 -26.011,29.745 -26.011,29.745l-3.415,15.83l7.373,-3.255c0,0 -1.197,-3.878 -7.372,-5.17"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/edit-button.f49c21157b29ecccf8da850f23836974.svg";
export { ForwardRef as ReactComponent };